var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"rj-layout-header"},[_c('div',{staticClass:"rj-layout-logo"}),_c('div',{staticClass:"rj-layout-title"},[_vm._t("title")],2),_c('div',{staticClass:"rj-layout-right"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }